import actions from './actions';
import getters from './getters'
import mutations from './mutations';


const getDefaultState = () => ({
  customerId : null,
  type : '1',
  reservationReminder : {
    type:'RESERVATION_REMINDER',
    configuration: {},
  },
  company : {
    id : null,
    name : '',
    usual_name : '',
    phone : '',
    email : '',
    contacts : [],
    phoneExt : null,
  },
  contact : {
    first_name : '',
    last_name : '',
    email : '',
    phone : '',
    phoneExt : null,
    sex : null,
    denomination:null,
  },
  settings : {
      customerClass : null,
      tags : [],
      currency : null,
      language : null,
      paymentMethods : [],
      term : null,
      lateFeeActivated : null,
      indTypeFee : null,
      fee : null,
      gracePeriod : null,
      deliveryType : null,
      location : null,
      reminderActivated : null,
      // reminderType : 1,
      // reminders : [],
      invoiceReminders : [],
      // nbDaysReminder : null,
      reservationNotificationInd: null,
      reservationNotificationType: null,
      reservationNotificationEmailCustomContent: null,
      lateFeeReminderActivated : null,
      customerDeliverySchedules:[],
      invoice_before_processing : false,
      online_invoicing_ind : true,
      taxes : [],
      taxable: true,
  },
  parent : null,
  externalId: null,
  territory : null,
  rep_id : null,
  addresses : [],
  ctrlDisabled : false,
  terms : [
    {
      id : 8,
      label : 'NET_0',
      value : 'P0D'
    },
    {
      id : 1,
      label : 'NET_15',
      value : 'P15D'
    },
    {
      id : 2,
      label : 'NET_30',
      value : 'P30D'
    },
    {
      id : 3,
      label : 'NET_45',
      value : 'P45D'
    },
    {
      id : 4,
      label : 'NET_60',
      value : 'P60D'
    },
    {
      id : 5,
      label : 'END_MONTH',
      value : 'END_MONTH'
    },
    {
      id : 6,
      label : 'END_NEXT_MONTH',
      value : 'END_NEXT_MONTH'
    },
    {
      id : 7,
      label : 'CUSTOM',
      value : null
    }
  ]
});

export default {
  namespaced: true,
  state: getDefaultState(),
  actions,
  getters,
  mutations,
  getDefaultState,
};
